import React from 'react'

import {
  DateTimeField,
  FieldSpec,
  JSONField,
  PaginatedTable,
  ProfileField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  type: { id: 'type', label: 'Type', renderer: ValueField },
  data: { id: 'data', label: 'Data', renderer: JSONField },
  by: { id: 'by', label: 'By', renderer: ProfileField },
  on: { id: 'on', label: 'Occurred On', renderer: DateTimeField },
  }

export const EventListTable = (props: ListTableProps) => {
  const { paginator, title, fields } = props

  return (
    <>
      <PaginatedTable
        title={title || 'Events'}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
      />
    </>
  )
}
